import { SET_EDITVEHICLE } from '../actions';

const vehicleedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITVEHICLE:
      return [...action.value];  
    default: return state;
  }
}

export default vehicleedit;
